import { render } from "./CardOrUnmatched.vue?vue&type=template&id=0ee3602c&ts=true"
import script from "./CardOrUnmatched.vue?vue&type=script&lang=ts"
export * from "./CardOrUnmatched.vue?vue&type=script&lang=ts"

import "./CardOrUnmatched.vue?vue&type=style&index=0&id=0ee3602c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__